import { render, staticRenderFns } from "./mis-favoritos.vue?vue&type=template&id=25cdc5f4&"
import script from "./mis-favoritos.vue?vue&type=script&lang=js&"
export * from "./mis-favoritos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports